export default __webpack_public_path__ + "static/media/online-pk-9-banner-graphics.ec2386da.svg";